// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model_card[data-v-6eec585e] {
  border-radius: 10px;
  max-width: 500px;
}
.model_card .max_200[data-v-6eec585e] {
  max-width: 200px;
}
.model_card img[data-v-6eec585e] {
  max-height: 150px;
}
.model_card h2[data-v-6eec585e] {
  font-size: 50px;
  opacity: 0.5;
}
.model_card p[data-v-6eec585e] {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiSelectedModel.vue","webpack://./AiSelectedModel.vue"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,gBAAA;ACAF;ADFA;EAKI,gBAAA;ACAJ;ADLA;EASI,iBAAA;ACDJ;ADRA;EAaI,eAAA;EACA,YAAA;ACFJ;ADZA;EAkBI,eAAA;ACHJ","sourcesContent":["\n.model_card {\n  border-radius: 10px;\n  max-width: 500px;\n\n  .max_200 {\n    max-width: 200px;\n  }\n\n  img {\n    max-height: 150px;\n  }\n\n  h2 {\n    font-size: 50px;\n    opacity: 0.5;\n  }\n\n  p {\n    font-size: 20px;\n  }\n\n}\n",".model_card {\n  border-radius: 10px;\n  max-width: 500px;\n}\n.model_card .max_200 {\n  max-width: 200px;\n}\n.model_card img {\n  max-height: 150px;\n}\n.model_card h2 {\n  font-size: 50px;\n  opacity: 0.5;\n}\n.model_card p {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
